import { Component, OnInit, AfterViewInit, ViewChild, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ProviderSidebarComponent } from '../sidebar/provider-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { AssetRequestComponent } from '../../shared/components/asset-request/asset-request.component';
import { AclApdApiService } from '@angular-workspace/services';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-provider-access-requests',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ProviderSidebarComponent,
    PageHeaderComponent,
    AssetRequestComponent,
  ],
  templateUrl: './access-requests.component.html',
  styleUrl: './access-requests.component.scss',
})
export class ProviderAccessRequestsComponent implements OnInit, AfterViewInit {
  @ViewChild(AssetRequestComponent) assetRequestComponent!: AssetRequestComponent;
  
  private aclApdApiService = inject(AclApdApiService);
  private cdr = inject(ChangeDetectorRef);
  private keycloak = inject(KeycloakService);

  async ngOnInit(): Promise<void> {
    // Data loading moved to ngAfterViewInit to ensure ViewChild is available
  }

  async ngAfterViewInit(): Promise<void> {
    // Wait for next tick to ensure child component is fully initialized
    await Promise.resolve();
    
    // Wait for Keycloak to be ready before making API calls
    await this.waitForKeycloakReady();
    
    await this.loadProviderAssetRequests();
  }

  private async waitForKeycloakReady(): Promise<void> {
    try {
      const keycloakInstance = this.keycloak.getKeycloakInstance();
      
      // If Keycloak is already initialized and has a token, proceed immediately
      if (keycloakInstance?.authenticated && keycloakInstance?.token) {
        console.log('Keycloak is ready, token available');
        return;
      }
      
      // Wait for Keycloak to be initialized (max 5 seconds)
      const maxWaitTime = 5000; // 5 seconds
      const checkInterval = 100; // Check every 100ms
      const startTime = Date.now();
      
      while (Date.now() - startTime < maxWaitTime) {
        const instance = this.keycloak.getKeycloakInstance();
        if (instance?.authenticated && instance?.token) {
          console.log('Keycloak is ready after waiting');
          return;
        }
        await new Promise(resolve => setTimeout(resolve, checkInterval));
      }
      
      console.warn('Keycloak ready check timed out, proceeding anyway');
    } catch (error) {
      console.error('Error waiting for Keycloak:', error);
      // Proceed anyway - the API calls will handle 401 errors
    }
  }

  async loadProviderAssetRequests(): Promise<void> {
    try {
      // Ensure the child component is available
      if (!this.assetRequestComponent) {
        console.error('AssetRequestComponent not available');
        return;
      }

      const page = this.assetRequestComponent.pagination?.currentPage || 1;
      const size = this.assetRequestComponent.pagination?.pageSize || 10;
      
      console.log('Loading provider asset requests - page:', page, 'size:', size);
      const response = await this.aclApdApiService.providerAssetRequests(page, size);
      console.log('Provider asset requests loaded:', response);
      
      // Map the response to the table data
      this.assetRequestComponent.mapProviderAssetRequestsResponse(response);
      
      // Trigger change detection to ensure view updates
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error loading provider asset requests:', error);
      // Set loading to false in case of error
      if (this.assetRequestComponent) {
        this.assetRequestComponent.loading = false;
      }
    }
  }
}



